var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons industries"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2188_228",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 40,
    height: 40,
    fill: "#3470E4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2188_228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "construction",
    d: "M31.5 35.0002L22.375 25.8752L25.875 22.3752L35 31.5002L31.5 35.0002ZM8.49996 35.0002L4.99996 31.5002L16.5 20.0002L13.6666 17.1668L12.5 18.3335L10.375 16.2085V19.6252L9.20829 20.7918L4.16663 15.7502L5.33329 14.5835H8.74996L6.66663 12.5002L12.5833 6.5835C13.1388 6.02794 13.7361 5.62516 14.375 5.37516C15.0138 5.12516 15.6666 5.00016 16.3333 5.00016C17 5.00016 17.6527 5.12516 18.2916 5.37516C18.9305 5.62516 19.5277 6.02794 20.0833 6.5835L16.25 10.4168L18.3333 12.5002L17.1666 13.6668L20 16.5002L23.75 12.7502C23.6388 12.4446 23.5486 12.1252 23.4791 11.7918C23.4097 11.4585 23.375 11.1252 23.375 10.7918C23.375 9.15294 23.9375 7.771 25.0625 6.646C26.1875 5.521 27.5694 4.9585 29.2083 4.9585C29.625 4.9585 30.0208 5.00016 30.3958 5.0835C30.7708 5.16683 31.1527 5.29183 31.5416 5.4585L27.4166 9.5835L30.4166 12.5835L34.5416 8.4585C34.7361 8.84739 34.868 9.22933 34.9375 9.60433C35.0069 9.97933 35.0416 10.3752 35.0416 10.7918C35.0416 12.4307 34.4791 13.8127 33.3541 14.9377C32.2291 16.0627 30.8472 16.6252 29.2083 16.6252C28.875 16.6252 28.5416 16.5974 28.2083 16.5418C27.875 16.4863 27.5555 16.3891 27.25 16.2502L8.49996 35.0002Z",
    fill: "#5D8DE9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/Construction.aa6ba87464b5dcdd287036c86e6a8450.svg";
export { ForwardRef as ReactComponent };